/** @format */

import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import classNames from 'classnames';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Typography from '../../../elements/Typography';
import GuestInfo from './GuestInfo';
import styles from './jobs.module.css';
import batmanFace from '../../../../assets/batman-face.png';
import scrollDownImg from '../../../../assets/scroll-down.png';
import { JOB_EXPERIENCE } from '../../../../constants/commons';

export default function Jobs() {
  function handleAnimation() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(ScrollToPlugin);

    const mottoWrapper = document.querySelector('.tech-stack');

    function getScrollAmount() {
      let racesWidth = mottoWrapper.scrollWidth;
      return -(racesWidth - window.innerWidth);
    }

    const timeline = gsap.timeline();
    timeline.to(mottoWrapper, {
      x: getScrollAmount,
      duration: 3,
      ease: 'none',
    });

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.tech-stack-section',
      start: 'top top',
      end: () => `+=${getScrollAmount() * -1} `,
      invalidateOnRefresh: true,
      pin: true,
      scrub: 1,
      markers: false,
    });
  }

  useGSAP(() => {
    handleAnimation();
  });

  return (
    <>
      <section
        className={classNames(
          styles['tech-stack-section'],
          'tech-stack-section'
        )}
      >
        <div className={styles['tech-stack-batman']}>
          <img alt="batman" src={batmanFace}></img>
        </div>
        <div className={classNames(styles['tech-stack'], 'tech-stack')}>
          <Typography>React.JS</Typography>
          <Typography>Node.JS</Typography>
          <Typography>Express.JS</Typography>
          <Typography>MongoDB</Typography>
          <Typography>🚀</Typography>
        </div>
        <div className={classNames(styles['scroll-down'], 'scroll-down')}>
          <img alt="scroll down" src={scrollDownImg}></img>
          <Typography as="p" className={classNames(styles['scroll-text'])}>
            Keep Scrolling
          </Typography>
        </div>
      </section>
      <ExperienceSection />
    </>
  );
}
function ExperienceSection() {
  function handleAnimation() {
    gsap.registerPlugin(ScrollTrigger);

    const mottoWrapper = document.querySelector('.tech-stack');

    // Using it here because previous section has horizontal indefinite scroll.
    function getScrollAmount() {
      let racesWidth = mottoWrapper.scrollWidth;
      return racesWidth - window.innerWidth;
    }

    const timeline = gsap.timeline();
    timeline.from('.experience-card', {
      x: -100,
      duration: 1,
      opacity: 0,
      stagger: 0.5,
      ease: 'bounce.out',
    });

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.experience-section',
      start: () => getScrollAmount() + 'top 40%',
    });
  }

  useGSAP(() => {
    handleAnimation();
  });

  return (
    <section
      className={classNames(styles['experience-section'], 'experience-section')}
    >
      <article className={styles['timeline']}>
        {JOB_EXPERIENCE.map((job, index) => (
          <div key={index} className={styles['timeline-step']}>
            <div className={styles['timeline-circle']}>
              {job.company ? <Typography>{job.company[0]}</Typography> : null}
            </div>
            <ExperienceCard {...job} />
          </div>
        ))}
      </article>
      <GuestInfo />
    </section>
  );
}

function ExperienceCard(props) {
  const { company, location, designation, description, tenure } = props;
  const { from, to } = tenure || {};

  return (
    <article
      className={classNames(styles['experience-card'], 'experience-card')}
    >
      <Typography className={styles['company-name']}>{company}</Typography>
      <div className={styles['company-tenure-location']}>
        <Typography>{location}</Typography>
        <Typography>
          {from ? from.toLocaleDateString('en-GB') : ''} -{' '}
          {to
            ? to.toDateString() === new Date().toDateString()
              ? 'present'
              : to.toLocaleDateString('en-GB')
            : ''}
        </Typography>
      </div>
      <Typography className={styles['job-title']}>{designation}</Typography>
      <Typography className={styles['job-description']}>
        {description}
      </Typography>
    </article>
  );
}
